<template>
    <div>
        <breadcrumb :routerList="[{to:'/agent/weekMeeting',title:'周清会议列表'},{title:'查看周会议纪要'}]"/>

        <div class="h-content">

            <div class="h-row h-mrt0">
                <div class="h-rowIn">

                    <div class="h-rowBox">
                        <el-form  ref="form1" :model="f" >
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>查看周会议纪要</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine ">

                                            <div class="margin-top el-descriptions">
                                                <div class="el-descriptions__body">
                                                    <table class ="meeting-table el-descriptions__table is-bordered ">
                                                        <tr>
                                                            <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">客户基本信息</th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                经销商名称
                                                            </th>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="agentName" >
                                                                    <el-input v-model="f.agentName" readonly></el-input>
                                                                </el-form-item>

                                                            </td>
                                                            <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">签约渠道</th>
                                                            <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="channelName" >
                                                                    <el-input v-model="f.channelName" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">运营会时间（周次）</th>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="weekStr" >
                                                                    <el-input v-model="f.weekStr" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">召开人</th>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-input v-model="f.conveneName" placeholder="请输入" readonly></el-input>
                                                            </td>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">参会人</th>
                                                            <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="participants" >
                                                                    <el-input v-model="f.participants" readonly></el-input>
                                                                </el-form-item>

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">客户签约目标</th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="5"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月度履约</th>
                                                            <th colspan="7"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本周进展</th>
                                                        </tr>
                                                        <tr>
                                                            <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月份</th>
                                                            <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月目标</th>
                                                            <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月预计达成</th>
                                                            <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">履约率（%）</th>
                                                            <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月累计（万）</th>
                                                            <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">下周预计下单（万）</th>
                                                            <th colspan="6" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">下周预计下单（万）</th>
                                                        </tr>
                                                        <tr>
                                                            <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">样本网 </th>
                                                            <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">药品网</th>
                                                            <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">云眼网</th>
                                                            <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">培养箱</th>
                                                            <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">离心机</th>
                                                            <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">血液/疫苗网</th>
                                                        </tr>
                                                        <tr>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="month" >
                                                                    <template slot-scope="scope">
                                                                        <div style="text-align: right;">
                                                                            {{f.month}}
                                                                        </div>
                                                                    </template>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="monthTarget" >
                                                                    <template slot-scope="scope">
                                                                        <div style="text-align: right;">
                                                                            {{f.monthTarget }}
                                                                        </div>
                                                                    </template>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="monthExpect" >
                                                                    <el-input v-model="f.monthExpect" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="completionRate" >
                                                                    <template slot-scope="scope">
                                                                        <div style="text-align: right;">
                                                                            {{f.completionRate }}
                                                                        </div>
                                                                    </template>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="monthTotal" >
                                                                    <template slot-scope="scope">
                                                                        <div style="text-align: right;">
                                                                            {{f.monthTotal }}
                                                                        </div>
                                                                    </template>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpect" >
                                                                    <template slot-scope="scope">
                                                                        <div style="text-align: right;">
                                                                            {{f.nextWeekExpect }}
                                                                        </div>
                                                                    </template>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpectYb" >
                                                                    <el-input v-model="f.nextWeekExpectYb" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpectYp" >
                                                                    <el-input v-model="f.nextWeekExpectYp" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpectYy" >
                                                                    <el-input v-model="f.nextWeekExpectYy" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpectPyx" >
                                                                    <el-input v-model="f.nextWeekExpectPyx" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpectLxj" >
                                                                    <el-input v-model="f.nextWeekExpectLxj" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekExpectUsj" >
                                                                    <el-input v-model="f.nextWeekExpectUsj" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">本月重点落地任务</th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="4"class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">重点落地任务描述 </th>
                                                            <th colspan="4"class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本周进展总结</th>
                                                            <th colspan="4" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">下周计划</th>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="4" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="keyTask" >
                                                                    <el-input type="textarea" maxlength="500" readonly show-word-limit v-model="f.keyTask"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="4" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="weekProgressSummary" >
                                                                    <el-input type="textarea" maxlength="500" readonly show-word-limit v-model="f.weekProgressSummary"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="4" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="nextWeekPlan" >
                                                                    <el-input type="textarea" maxlength="500" readonly show-word-limit v-model="f.nextWeekPlan"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                        <tr>
                                                            <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">本周亮点</th>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="12" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="weekHighlight" >
                                                                    <el-input type="textarea" maxlength="500" readonly show-word-limit v-model="f.weekHighlight"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">竞争对手分析</th>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="12" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="competitorAnalysis" >
                                                                    <el-input type="textarea" maxlength="500" readonly show-word-limit v-model="f.competitorAnalysis"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">协同问题</th>
                                                        </tr>

                                                        <tr>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">链群</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="lianqunName" >
                                                                    <el-input v-model="f.lianqunName" readonly></el-input>
                                                                </el-form-item>

                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">问题分类</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="problemTypeName" >
                                                                    <el-input v-model="f.problemTypeName" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">影响及紧急程度</th>
                                                            <td   colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="influenceLevel" >
                                                                    <el-input  v-model="f.influenceLevel" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">资源需求类型</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="problemDeptTypeName" >
                                                                    <el-input v-model="f.problemDeptTypeName" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">要求到位时间</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="endDate" >
                                                                    <el-date-picker
                                                                            :clearable="false"
                                                                            type="date"
                                                                            value-format="yyyy-MM-dd"
                                                                            placeholder="选择时间"
                                                                            v-model="f.endDate"
                                                                            style="width: 100%;"
                                                                            readonly
                                                                    ></el-date-picker>
                                                                </el-form-item>
                                                            </td>

                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">承接部门</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="jobGroup" >
                                                                    <el-input v-model="f.jobGroup" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">答复人</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="pointUser" >
                                                                    <el-input v-model="f.pointUser" readonly></el-input>
                                                                </el-form-item>

                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">协同问题</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="dailyQuestion" >
                                                                    <el-input type="textarea" maxlength="500" show-word-limit v-model="f.dailyQuestion" readonly></el-input>
                                                                </el-form-item>
                                                            </td>

                                                        </tr>


                                                        <tr>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">会议照片</th>
                                                            <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                                              <div style="float: left;width:200px">
                                                                <el-image
                                                                    style="width: 200px; height: 100px"
                                                                    :src="url"
                                                                    :preview-src-list="srcList">
                                                                </el-image>
                                                              </div>
                                                            </td>
                                                            <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">

                                                            </td>

                                                        </tr>

                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>


            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>

            </div>
        </div>
    </div>
</template>

<script>
    import shoudf from '../../../../components/dialog/selectshdf'
    import weekMeetingService from "../../../../api/loud/weekMeeting/weekMeetingService.js";
    import ss from "../../../../api/SystemService";
    import uploaddown from "../../../../utils/updownfile";


    export default {

        components: {
            shoudf
        },

        data() {

            return {
                //表单
                f:{
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    channelCode:null, // 经销商渠道
                    channelName:null, // 经销商渠道
                    weekTime:null, // 运营会时间-周
                    weekStr:null, //周范围字符串
                    weekMonth:null,//运营会时间-月（该周属于几月份）
                    weekYear:null, //运营会时间-年（该周属于哪一年）
                    conveneCode:null, // 召开人编码
                    conveneName:null, // 召开人名称
                    participants:null, // 参会人员
                    month:null, // 月份
                    monthTarget:null, // 本月目标
                    monthExpect:null, // 本月预计达成
                    completionRate:null, // 履约率
                    monthTotal:null, // 本月累计（万）
                    nextWeekExpect:null, // 下周预计下单（万）
                    nextWeekExpectYb:null, // 下周预计下单-样本网
                    nextWeekExpectYp:null, // 下周预计下单-药品网
                    nextWeekExpectYy:null, // 下周预计下单-云眼网
                    nextWeekExpectPyx:null, // 下周预计下单-培养箱
                    nextWeekExpectLxj:null, // 下周预计下单-离心机
                    nextWeekExpectUsj:null, // 下周预计下单-血液/疫苗网
                    keyTask:null, // 重点任务描述
                    weekProgressSummary:null, // 本周进展总结
                    nextWeekPlan:null, // 下周计划
                    weekHighlight:null, // 本周亮点
                    competitorAnalysis:null, // 对手分析

                    /*problemDescription:null, // 问题描述
                    collaborator:null, // 协同人
                    arrivalTime:null, // 到位时间*/
                    lianqun:null, // 链群
                    lianqunName:null, // 链群
                    problemType:null, // 提出问题分类
                    problemTypeName:null, // 提出问题分类
                    endDate:null, // 回答时间
                    influenceLevel:null, // 影响及紧急程度
                    problemDeptType:null, // 资源需求类型
                    problemDeptTypeName:null, // 资源需求类型
                    dailyQuestion:null, // 协同问题
                    jobGroup:null, // 承接部门
                    pointUser:null, // 用户名称--用户编码
                    jobUsername:null, // 用户名称
                    jobUsercode:null, // 用户名称


                    score:null, // 评分
                    summarize:null, // 总结

                },
                refid:null,
                dialogVisible:false,
                dialogImageUrl:"",
                rules: {

                },
                files:[],
                fileList:[],
                url:'',
                srcList:[],
            }
        },

        created() {
            this.f.id =  this.$route.query.id;
            this.query(this.f.id);
        },


        methods: {
            //
            query(id) {
                 weekMeetingService.selectById(id).then(rd => {
                    this.f= rd.obj;
                    this.refid = this.f.fileId;
                    //查询文件
                   weekMeetingService.selectMeetingReportFile(this.f).then(rd => {
                        console.log("rd",rd)
                     rd.msg.forEach(obj => {
                       console.log(obj)
                       console.log("process.env.VUE_APP_AJAXURL",process.env.VUE_APP_AJAXURL+'/'+obj.saveurl)
                       this.srcList.push('https://'+process.env.VUE_APP_AJAXURL+'/'+obj.saveurl);
                     })
                      this.url = 'https://'+process.env.VUE_APP_AJAXURL+'/'+rd.msg[0].saveurl;
                     console.log(this.url,"url")
                   })
                 })
            },
            //返回
            backS() {
              this.$router.go(-1);
            },
        }

    }


</script>
<style scoped lang="scss">
    ::v-deep .meeting-table  th ,td {

        text-align: center!important;
        border: 1px solid #303133!important;
        vertical-align:middle;

    }
    ::v-deep .my-label {
        background: #fff2e5!important;

    }
    ::v-deep .my-label-lab {
        background: #E8F5F8!important;

    }
    ::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }

    ::v-deep .el-form-item {
        margin-bottom: 0 !important;
    }
    .new-yulan{
      width: 100%;
      margin: 0 auto;
    }
    .new-yulan ul li{
      padding:5px 0
    }
    .new-yulan ul li h3{
      text-align: left;
      font-weight: 400;
      color: #0e75e9;
      font-size: 14px
    }
    .new-yulan ul li h3 i{
      padding: 0 5px;
      color: #606266
    }
    .new-yulan ul li h3 span{
      text-align: right;
      color: #606266;
      float: right;
      font-size: 13px
    }
</style>
<style>
.icon:hover{
  color: rgb(0, 174, 255);
}
</style>
